






















































































































import Vue from "vue";
import { codemirror } from "vue-codemirror";
import "codemirror/lib/codemirror.css";
import "codemirror/mode/javascript/javascript.js";
import "codemirror/mode/clike/clike.js";
import "codemirror/theme/base16-dark.css";
import "codemirror/theme/monokai.css";

export default Vue.extend({
  name: "ProgrammingTask",
  components: {codemirror},
  props: ["task", "lang"],
  data() {
    return {
      userFunction: this.task.functionStart[this.lang],
      programmingLang: this.lang,
      showLibrary: false,
      cmOptions: {
        tabSize: 4,
        mode: "text/javascript",
        theme: "monokai",
        lineNumbers: true,
        line: true
      }
    };
  },

  watch: {
    task() {
      this.programmingLang = this.lang;
      this.userFunction = this.task.functionStart[this.lang];
    }
  },

  methods: {
    setMode(lang) {
      switch (lang) {
        case "js":
          Vue.set(this.cmOptions, "mode", "text/javascript");
          break;
        case "java":
          Vue.set(this.cmOptions, "mode", "text/x-java");
          break;
        case "cpp":
          Vue.set(this.cmOptions, "mode", "text/x-c++src");
          break;
      }

      this.programmingLang = lang;
      this.userFunction = this.task.functionStart[lang];
    },

    changeFunction() {
      this.$set(this.task.functionStart, this.programmingLang, this.userFunction);

      this.$emit("changeFunction", {
        lang: this.programmingLang,
        taskNumber: this.task.number,
        userFunction: this.userFunction
      });
    },

    handleInput(instance, changeObj) {
      this.$emit("userAction", {
        lang: this.programmingLang,
        taskNumber: this.task.number,
        event: "input",
        input: changeObj.text.join(" "),
        timestamp: Date.now()
      });
    },

    handleCopy() {
      this.$emit("userAction", {
        lang: this.programmingLang,
        taskNumber: this.task.number,
        event: "descriptionCopied",
        timestamp: Date.now()
      });
    }
  }
});
